import { Component, DestroyRef, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { StartWorkDoneResponse } from '#models';
import { StartWorkDoneService } from 'src/services/api/start-work-done.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToasterService } from '#services';

export interface AddQuestionComponentConfig {
  startWorkDoneId: number;
  controlId: number;
}
@Component({
  selector: 'app-add-question',
  imports: [ReactiveFormsModule, ButtonModule, SelectModule, TextareaModule, TranslatePipe],
  templateUrl: './add-question.component.html',
  styleUrl: './add-question.component.scss',
})
export class AddQuestionComponent {
  // startWorkDoneId = input(0);

  private _ref: DynamicDialogRef<AddQuestionComponent> = inject(DynamicDialogRef);
  private _config: DynamicDialogConfig<AddQuestionComponentConfig> = inject(DynamicDialogConfig);
  private _startWorkDoneService: StartWorkDoneService = inject(StartWorkDoneService);
  private _toasterService = inject(ToasterService);
  private _translateService = inject(TranslateService);
  private _destroyRef = inject(DestroyRef);

  description = '';
  formGroup = new FormGroup({
    name: new FormControl<string>('', Validators.required),
  });

  isInvalid = (controlName: string): boolean => {
    const control = this.formGroup.get(controlName);
    return !!(control && control.invalid);
  };

  onSave(): void {
    const response: StartWorkDoneResponse = {
      startWorkDoneId: this._config.data!.startWorkDoneId,
      name: this.formGroup.value.name!,
      controlId: this._config.data!.controlId,
    };

    this._startWorkDoneService
      .createResponse(response)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: data => {
          this._toasterService.showSuccess(this._translateService.instant('common.savedSuccessfully'));

          this._ref.close(data);
        },
      });
  }
  cancel(): void {
    this._ref.close();
  }
}
